import React, { Component } from 'react';
import selos2 from '../images/selos2.png';
import { Link } from 'react-router-dom';


class confirmation extends Component {
    constructor(props){
        super(props);
    }

    returnTo = () => {
        this.props.changeConfirmation("init",false);
    }

    render() {
        return (
            <div className="content-left confirm">
                <h2>CONFIRMAÇÃO NÚMERO</h2>
                <h2>{ this.props.numberFormat }</h2>
                <p>CONFIRME SEU NÚMERO OU ALTERE.</p>
                
                <Link to={{
                    pathname: "/Recarga" ,
                    state:{
                        numberFormat: this.props.numberFormat,
                        number: "55"+this.props.number,
                        token: this.props.token
                    }
                }}>
                    <div className="content-left--input-btn-confirm">
                        CONFIRMAR
                    </div>
                </Link>


                <div onClick={this.returnTo} className="content-left--input-btn-change-celular">
                    ALTERAR CELULAR
                </div>

                <div className="content-left-selos">
                    <img src={selos2} alt="selos"/>
                </div>
            </div>
        )
    }
}

export default confirmation; // Don’t forget to use export default!